import apiClient from './apiClient';

export async function fetchSocQueue() {
  const { data } = await apiClient.get('/soc/queue');
  return data;
}

export async function fetchSocShifts() {
  const { data } = await apiClient.get('/soc/shifts');
  return data;
}

export async function fetchOnDutyNow() {
  const { data } = await apiClient.get('/soc/shifts/on-duty');
  return data;
}

export async function createSocShift(payload) {
  const { data } = await apiClient.post('/soc/shifts', payload);
  return data;
}
